// pages/admin/Campaign/hooks/useCampaigns.js
import { useState, useEffect, useCallback } from 'react';
import axiosInstance from 'axios';
import { Admin_Campaign } from '../../../../constants';

export const useCampaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCampaigns = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axiosInstance.get(
        `${Admin_Campaign}`
      );

      if (response.data.success) {
        setCampaigns(response.data.data);
      } else {
        throw new Error('API returned success: false');
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to fetch campaigns';
      setError(errorMessage);
      console.error('Campaign fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCampaigns();
  }, [fetchCampaigns]);

  const totalEmployees = campaigns.reduce(
    (sum, campaign) => sum + campaign.Employees.length,
    0
  );

  return {
    campaigns,
    loading,
    error,
    refetch: fetchCampaigns,
    totalEmployees,
  };
};
